import { useAuth, useClerk } from "@clerk/react";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

import { FullPageLoader } from "@/web/components/styled/FullPageLoader";
import { LinkButton } from "@/web/components/styled/LinkButton";
import { usePostHog } from "@posthog/react";

export const Route = createFileRoute("/logout")({
  component: LogoutRoute,
});

function LogoutRoute() {
  const { isLoaded, isSignedIn } = useAuth();
  const { signOut, client } = useClerk();
  const logoutStarted = useRef(false);
  const posthog = usePostHog();

  useEffect(() => {
    if (!isLoaded || !isSignedIn || logoutStarted.current) {
      return;
    }
    logoutStarted.current = true;

    void (async () => {
      await client?.destroy?.();
      await signOut();
      posthog.reset();
      window.location.href = "/";
    })();
  }, [isLoaded, isSignedIn, client, signOut, posthog]);

  if (!isLoaded) {
    return <FullPageLoader />;
  }

  if (!isSignedIn) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-6 px-6">
        <p className="text-center font-heading text-xl text-foreground">
          You&apos;re not logged in!
        </p>
        <LinkButton variant="solid" color="blue" to="/">
          Back to home
        </LinkButton>
      </div>
    );
  }

  return <FullPageLoader />;
}
